import { Component, inject, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { skip, tap } from 'rxjs/operators';
import { AuthService } from './auth/services/auth.service';
import { TrackingService } from './shared/services/tracking.service';
import { FooterComponent } from './static/footer/footer.component';
import { HeaderComponent } from './static/header/header.component';

@Component({
    selector: 'shig-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],

    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent implements OnInit {
    private router = inject(Router);
    private translate = inject(TranslateService);
    private tracking = inject(TrackingService);
    private authService = inject(AuthService);

    private title: string = 'sag-interview-generator';
    private previousPath: string | undefined;

    constructor() {
        this.translate.setDefaultLang('en');
        const lang = localStorage.getItem('language');
        if (lang !== null && lang !== 'null') {
            this.translate.use(lang);
        } else {
            this.translate.use('en');
        }

        this.router.events.subscribe((res) => {
            window.scrollTo(0, 0);
            if (res instanceof NavigationStart && !res.url.startsWith('/auth')) {
                void this.tracking.addWCSTrackingItem('route', res.url);
            }
        });

        this.translate.onLangChange
            .pipe(
                skip(1),
                tap(() => void this.tracking.addWCSTrackingItem('language', 'Language Changed'))
            )
            .subscribe();
    }

    ngOnInit(): void {
        this.routeToRedirect();
    }

    private routeToRedirect(): boolean {
        const url = window.localStorage.getItem('redirectUrl');
        if (url) {
            void this.router.navigateByUrl(url);
            window.localStorage.removeItem('redirectUrl');
        }
        return !!url;
    }
}
